import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function NewsHighlightedSummarySchema() {
  const { t } = useTranslation('panel')

  return z.object({
    title: z.string().max(100).optional(),
    subtitle: z.string().max(100).optional(),
    tag: z
      .array(
        z.object({
          label: z.string(),
          value: z.string(),
        }),
      )
      .min(1)
      .default([]),
    postExternalUrl: z
      .string()
      .optional()
      .refine(
        (url) => {
          if (!url) return true
          return new RegExp(
            '^www\\.' + // www required
              '[a-zA-Z0-9]+(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?' + // Principal domain (1+ chars, no special chars at end)
              '(?:\\.[a-zA-Z0-9]+(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)?' + // Subdomain optional (e.g., .com in .com.br)
              '\\.' + // Dot required
              '[a-zA-Z]{2,}' + // Final extension required (2+ letters)
              '(?:/.*)?$', // Path optional
          ).test(url)
        },
        {
          message: t('news.drawer_create_news.summary.schema.url_invalid'),
        },
      ),
    postFile: z.instanceof(File).optional(),
  })
}

export type NewsHighlightedSummaryForm = z.infer<
  ReturnType<typeof NewsHighlightedSummarySchema>
>
